import { downloadSystemConfigFile } from "http/UAM/systemConfig.helper"
import moment from "moment"
import localStorage from "redux-persist/es/storage"
import CryptoJS from "crypto-js";

export const getRoleName = (roleId) => {
    if (roleId == 1) {
        return "Admin"
    } else if (roleId == 2) {
        return "depot"
    } else if (roleId == 3) {
        return "customer"
    } else if (roleId == 4) {
        return "sales"
    } else {
        return null;
    }
}

export const getToken = async () => {
    try {
        const dataString = await localStorage.getItem("tokens");
        if (dataString) {
            const data = JSON.parse(dataString);
            return data;
        }
    } catch (e) {
        console.error("Error retrieving or parsing token data", e);
    }
    return null;
};


export const getUser = async (key) => {
    const encryptedData = await localStorage.getItem("user");
    if (encryptedData) {
        const decrypted = decryptedValue(encryptedData)
        return key ? decrypted[key] : decrypted;
    }
    return null;
}

export const decryptedValue = (encryptedData) => {
    if (!encryptedData) return null; 
    
    try {
      const passphrase = process.env.REACT_APP_KEY;
      const decrypted = CryptoJS.AES.decrypt(encryptedData, passphrase).toString(CryptoJS.enc.Utf8);
      return JSON.parse(decrypted);
    } catch (error) {
      return null; 
    }
}

export const getPermission = async () => {
    const data = await localStorage.getItem("permissions");
    if (data) {
        const permissionJson = JSON.parse(data)
        return permissionJson;
    }

    return null

}

export const dateFormat = (date, format) => {
    if (moment(date).isValid())
        return moment(date).format(format)
    else
        return date
}

export const dateFormatChange = (date, inputFormat, outputFormat) => {
    if (moment(date, inputFormat).isValid())
        return moment(date, inputFormat).format(outputFormat)
    else
        return date
}



export const extractDomain = (url, key) => {
    let domain = (new URL(url));
    return domain[key]
}

export const downloadDocument = (url) => {
    const pathname = extractDomain(url, 'pathname')
    const filename = pathname.substring(pathname.lastIndexOf("/") + 1)
    const ext = filename.split(".").pop()
    const obj = {
        fileName: filename,
    }

    downloadSystemConfigFile(obj)
        .then(response => {
            if (response.code == 200) {
                const { result } = response
                downloadFile(result, ext, filename)
            }
        }).catch(e => {

        })

}

const downloadFile = (base64String, ext, fileName) => {
    let source = ""
    if (ext == "zip") {
        source = `data:application/zip;base64,${base64String}`
        const link = document.createElement("a")
        link.href = source
        link.download = fileName
        link.click()
    } else {
        source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64String}`
        const link = document.createElement("a")
        link.href = source
        link.download = fileName
        link.click()
    }
}

export const isPermission = async (permissionName, type) => {
    const permissionsStr = await localStorage.getItem("permissions")
    const permissions = JSON.parse(permissionsStr)
    const permission = permissions.find(p => p.permission_name == permissionName)
    if (!permission)
        return false
    else
        return permission[type] == 1
}

export const currencyShotern = (amount) => {
    if (amount && !isNaN(amount) && amount != undefined) {
        const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
            notation: 'compact',
            compactDisplay: 'long',
        })
        return formatter.format(amount)

    } else
        return "0.00"
}

const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
}

export const uId = () => {
    const randomKey = getRandomInt(1000000000)

    return `${randomKey}-${Date.now().toString(36)}`
}

export const formatNumberToCrores = (number) => {
    if (number !== null && number !== undefined) {
        const croreValue = number / 10000000;
        return `${croreValue}cr`;
    }
    return '';
}

export const formatNumberWithCommas = (number) => {    
    if(!number || number == 0) {
      return '-';
    } else {
      const formattedNumber = number.toFixed(2).toString().replace(/\./, ',');
      const parts = formattedNumber.split(',');
      if (parts[0].length > 3) {
        const lastThree = parts[0].substr(parts[0].length - 3);
        const remaining = parts[0].slice(0, parts[0].length - 3);
        parts[0] = remaining.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
      }
      let formattedPrice = '₹' + ' ' + parts.join('.');
      return formattedPrice;
    }
  };


  export const dealFilterList = [
    { label: "Accepted By Financiers", value: "accepted_by_financiers", selected: false },
    { label: "Associated Anchors", value: "anchor_id", selected: false },
    { label: "Closure Date", value: "expected_closure_date", selected: false },
    { label: "Company Name", value: "entity_name", selected: false },
    { label: "Created Date", value: "created_at", selected: false },
    { label: "Credit Ratings", value: "credit_rating", selected: false },
    { label: "Deal Name", value: "deal_name", selected: false },
    { label: "Deal Status", value: "deal_status", selected: false },
    { label: "FI RM", value: "assigned_to_firm", selected: false },
    { label: "Mandate signed", value: "mandate_signed", selected: false },
    { label: "MoU signed", value: "mou_signed", selected: false },
    { label: "Product", value: "product", selected: false },
    { label: "Product Type", value: "product_type", selected: false },
    { label: "Program Manager", value: "assigned_to_program_rm", selected: false },
    { label: "Prospective Product", value: "prospective_product", selected: false },
    { label: "Referred To Financiers", value: "referred_to_financiers", selected: false },
    { label: "Rejected By Financiers", value: "rejected_by_financiers", selected: false },
    { label: "RM", value: "assigned_to", selected: false },
    { label: "Entity Region", value: "region", selected: false },
    { label: "Sub Product", value: "sub_product", selected: false },
];


export const entityFilterList = [
    { label: "Associated Anchors Entity", value: "anchor_id", selected: false },
    { label: "Constitution", value: "constitution", selected: false },
    { label: "Entity Name", value: "entity_name", selected: false },
    { label: "Entity Type", value: "entity_type", selected: false },
    { label: "GSTN", value: "gstn_in", selected: false },
    { label: "PAN", value: "pan", selected: false }, 
    { label: "Region", value: "region", selected: false },
    { label: "RM (Entity)", value: "program_owner", selected: false },
    { label: "Status", value: "status", selected: false },

];

export const conditionOptions = [
    { label: 'Equal', value: 'equal' },
    { label: 'Not Equal', value: 'not_equal' },
    { label: 'Contains', value: 'contains' },
    { label: 'Not Contains', value: 'not_contains' },
];

export const dealStatusBucket = [
    { displayName: "Sent To Financier", id: 1, value: "sentToFinancier" },
    { displayName: "Submitted By Partner", id: 2, value: "submittedByPartner" },
    { displayName: "Draft", id: 3, value: "draft" },
    { displayName: "Submitted By Customer", id: 4, value: "submittedByCustomer" },
    { displayName: "Pending For Esign", id: 5, value: "pendingForEsign" },
    { displayName: "Prospect", id: 6, value: "prospect" },
    { displayName: "Meeting Done", id: 7, value: "meetingDone" },
    { displayName: "Wip", id: 8, value: "wip" },
    { displayName: "Referred", id: 9, value: "referred" },
    { displayName: "Queries", id: 10, value: "queries" },
    { displayName: "Approved", id: 11, value: "approved" },
    { displayName: "Rejected", id: 12, value: "rejected" },
    { displayName: "On Hold", id: 13, value: "onHold" },
    { displayName: "Pre Sanction Documents", id: 14, value: "PreSanctionDocuments" },
    { displayName: "Live", id: 15, value: "live" },
    { displayName: "Customer backed out", id: 16, value: "CustomerBackedOut" },
    { displayName: "Terms conditions not accepted", id: 17, value: "TermConditionsNotAccepted" },
    { displayName: "Deal lost", id: 18, value: "dealLost" },
    { displayName: "Sanctioned", id: 19, value: "sanctioned" },
    { displayName: "Credit Appraisal", id: 20, value: "sanctioned" },
    { displayName: "GST Karza Completed", id: 21, value: "GST Karza Completed" },
    { displayName: "PD Done", id: 22, value: "PD Done" }
];

export const entityConstitution = [
    { displayName: "Private Limited Company", value: "Private Limited Company" },
    { displayName: "Limited Liability Partnership", value: "Limited Liability Partnership" },
    { displayName: "Proprietorship", value: "Proprietorship" },
    { displayName: "Partnership", value: "Partnership" },
    { displayName: "Public Limited Company", value: "Public Limited Company" },
];

export const dealSummaryFIlters = [
    { label: "Closure Date", value: "expected_closure_date", selected: false },
    { label: "Deal Status", value: "deal_status", selected: false },
    { label: "Financiers", value: "financier", selected: false },
    { label: "Proposal Type", value: "proposal_type", selected: false },
    { label: "Partner Program", value: "partner_program", selected: false },
    { label: "Program RM", value: "assigned_to_program_rm", selected: false },
    { label: "RM", value: "assigned_to", selected: false },    
    // { label: "Deal Name", value: "deal_name", selected: false },
];

export const dealStatusBucketSummary = [
    { displayName: "Draft", id: 3, value: "draft" },
    { displayName: "Pending For Esign", id: 5, value: "pendingForEsign" },
    { displayName: "Rejected", id: 12, value: "rejected" },
    { displayName: "Pre Sanction Documents", id: 14, value: "PreSanctionDocuments" },
    { displayName: "Live", id: 15, value: "live" },
    { displayName: "Sanctioned", id: 19, value: "sanctioned" },
    { displayName: "Credit Appraisal", id: 20, value: "sanctioned" }
];

export const meetingFilters = [
    { label: "Created By", value: "created_by", selected: false },
    { label: "Filter By Entity", value: "entity_name", selected: false },
    { label: "Meeting Medium", value: "medium", selected: false },
    { label: "Meeting Status", value: "meeting_status", selected: false },
    { label: "Start Date", value: "start_date", selected: false },  
];